export default __webpack_public_path__ + "img/marker.fb946ade.svg";